class SlickClass {
  constructor() {
    this.init()
  }

  async init() {}

  async worksSlider() {
    const worksObject = document.querySelector("#bb-works")
    if (!worksObject) return

    const { default: axios } = await import(/* webpackChunkName: 'axios' */ "axios")
    const slick = await this.getSlick()

    const APP = new Vue({
      el: worksObject,
      data() {
        return {
          slide: [],
        }
      },
      async mounted() {
        const _this = this
        await axios.get("https://www.berry-b.jp/wp-json/wp/v2/work?per_page=12").then(function (res) {
          _this.slide = [...res.data]
        })

        const sliderOject = $("#bb-works-slider")
        sliderOject.not(".slick-initialized").slick({
          arrows: false,
          centerMode: true,
          centerPadding: "5px",
          slidesToShow: 9,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2500,
          draggable: true,
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
              },
            },
          ],
        })
      },
    })
  }

  async getSlick() {
    const { default: slick } = await import(/* webpackChunkName: 'slick-carousel' */ "slick-carousel")
    return slick
  }
}

export default new SlickClass()
